import { AbstractDTO } from "./abstract";

export class UserPropertyActionDTO extends AbstractDTO {

    activeInactive: boolean;
    createUser: boolean;
    editUser: boolean;
    inviteUser: boolean;

    constructor(attributes?: object) {
        super(attributes);
        attributes = attributes || {};
        this.activeInactive = attributes['active_inactive'] == '1';
        this.createUser = attributes['create_user'] == '1';
        this.editUser = attributes['edit_user'] == '1';
        this.inviteUser = attributes['invite_user'] == '1';
    }
}